import { AnimatedFAB } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

const UniAnimatedFAB = withUnistyles(AnimatedFAB)

export default UniAnimatedFAB
